import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled, { css } from 'styled-components';
//
import SoFormPanel from 'refactored/features/soForm/components/layout/SoFormPanel';
import SoFormRowContainer from 'refactored/features/soForm/components/layout/SoFormRowContainer';
import SoFormPanelText from 'refactored/features/soForm/components/layout/SoFormPanelText';
import { GirdedQuestionIcon } from 'refactored/ui/icons';
import SoFormAddShippmentButton from './SoFormAddShippmentButton';
import StopAddress from './StopAddress';
import CoverageModal from './CoverageModal';
import { useSelector } from 'react-redux';
import { selectors as settingsSelectors } from 'state/settings';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
`;

const SoFormAddresses = ({ className }) => {
  const [showModal, setShowModal] = useState(false);
  const countrySettings = useSelector(settingsSelectors.getCountrySettings);
  const isSpain = countrySettings.country === 'ES';
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <SoFormPanel>
        <SoFormRowContainer>
          <SoFormPanelText>
            {t('configuration.addresses.header')}
          </SoFormPanelText>
          {isSpain && <GirdedQuestionIcon onClick={() => setShowModal(true)} />}
        </SoFormRowContainer>
        <TempContainer>
          <StopAddress
            key={`directOrder-FIRST_SHIPMENT-pickup`}
            shipmentKey={'FIRST_SHIPMENT'}
            stopType={'pickup'}
          />
          <StopAddress
            key={`directOrder-FIRST_SHIPMENT-dropoff`}
            shipmentKey={'FIRST_SHIPMENT'}
            stopType={'dropoff'}
          />
          <SoFormAddShippmentButton />
        </TempContainer>
      </SoFormPanel>
      <CoverageModal showModal={showModal} setShowModal={setShowModal} />
    </div>
  );
};

SoFormAddresses.propTypes = {
  className: PropTypes.string,
};

const regularCSS = css`
  display: flex;
  flex-direction: row;
  width: 100%;
  /* position: relative; */
`;

export default styled(SoFormAddresses)`
  ${regularCSS}
`;
